// extracted by mini-css-extract-plugin
module.exports = {"root":"ToastUi_root__xFtWF","icon":"ToastUi_icon__LAole","neutral":"ToastUi_neutral__sHC_u","positive":"ToastUi_positive__sfGyX","alert":"ToastUi_alert__sixPv"};